/* eslint-disable sort-keys */
// TEMPORARY SOLUTION UNTIL BE ENDPOINT IS READY
export default Object.freeze([
  {
    country: 2, regex: '^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\\s?[0-9][A-Za-z]{2})$', example: 'AA11AA', type: 'text',
  }, // UK
  {
    country: 316, regex: '^JE|je\\d[\\dA-Za-z]?[ ]?\\d[ABD-HJLN-UW-Zabd-hjln-uw-z]{2}$', example: 'JE11UW', type: 'text',
  },
  {
    country: 313, regex: '^GY|gy\\d[\\dA-Za-z]?[ ]?\\d[ABD-HJLN-UW-Zabd-hjln-uw-z]{2}$', example: 'GY11UW', type: 'text',
  },
  {
    country: 315, regex: '^IM|im\\d[\\dA-Za-z]?[ ]?\\d[ABD-HJLN-UW-Zabd-hjln-uw-z]{2}$', example: 'IM11UW', type: 'text',
  },
  {
    country: 1, regex: '^\\d{5}([ \\-]\\d{4})?$', example: '11111, 11111-1111', type: 'tel',
  },
  {
    country: 3, regex: '^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv][ ]?\\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z]\\d$', example: 'A1A1A1', type: 'text',
  },
  {
    country: 30, regex: '^\\d{5}$', example: '11111', type: 'tel',
  }, // Turkey
  {
    country: 46, regex: '^\\d{3}-?\\d{4}$', example: '1111111, 111-1111', type: 'text',
  },
  {
    country: 28, regex: '^\\d{2}[ ]?\\d{3}$', example: '11111, 11 111', type: 'text',
  },
  {
    country: 4, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 45, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 201, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 108, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 89, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 66, regex: '^\\d{4}[ ][A-Za-z]{2}$', example: '1111 CC', type: 'text',
  }, // Netherlands
  {
    country: 113, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 23, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 91, regex: '^\\d{3}[ ]\\d{2}$', example: '111 11', type: 'text',
  },
  {
    country: 70, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 118, regex: '^\\d{5}[\\-]?\\d{3}$', example: '11111-111', type: 'text',
  },
  {
    country: 79, regex: '^\\d{4}[\\-]?\\d{3}?$', example: '1111-111', type: 'text',
  }, // Portugal
  {
    country: 27, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 301, regex: '^22\\d{3}$', example: '22111', type: 'tel',
  },
  {
    country: 49, regex: '^\\d{3}[\\-]?\\d{3}$', example: '111111, 111-111', type: 'text',
  },
  {
    country: 18, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 203, regex: '^\\d{3}(\\d{2})?$', example: '111, 11111', type: 'tel',
  },
  {
    country: 195, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 103, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 104, regex: '^AD|ad\\d{3}$', example: 'AD111', type: 'text',
  },
  {
    country: 107, regex: '^([A-HJ-NP-Za-hj-np-z])?\\d{4}([A-Za-z]{3})?$', example: '1111AAA', type: 'text',
  },
  {
    country: 7, regex: '^(37)?\\d{4}$', example: '371111, 1111', type: 'tel',
  },
  {
    country: 109, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 111, regex: '^((1[0-2]|[2-9])\\d{2})?$', example: '1111', type: 'tel',
  },
  {
    country: 9, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 112, regex: '^BB|bb\\d{5}?$', example: 'BB11111', type: 'text',
  },
  {
    country: 10, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 296, regex: '^[A-Za-z]{2}[ ]?[A-Za-z0-9]{2}$', example: 'AA11, AAAA', type: 'text',
  },
  {
    country: 117, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 307, regex: '^(BBND 1ZZ|bbnd 1zz)$', example: 'BBND 1ZZ', type: 'text',
  },
  {
    country: 119, regex: '^[A-Za-z]{2}[ ]?\\d{4}$', example: 'AA1111', type: 'text',
  },
  {
    country: 14, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 15, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 124, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 127, regex: '^\\d{7}$', example: '1111111', type: 'tel',
  },
  {
    country: 132, regex: '^\\d{4,5}|\\d{3}-?\\d{4}$', example: '111-1111', type: 'text',
  },
  {
    country: 21, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 134, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 22, regex: '^\\d{3}[ ]\\d{2}$', example: '111 11', type: 'text',
  },
  {
    country: 137, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 24, regex: '^([A-Za-z]\\d{4}[A-Za-z]|(?:[A-Za-z]{2})?\\d{6})?$', example: 'A1111A, 111111', type: 'text',
  },
  {
    country: 25, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 26, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 311, regex: '^\\d{3}$', example: '111', type: 'tel',
  },
  {
    country: 29, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 32, regex: '^\\d{3}[ ]?\\d{2}$', example: '111 11', type: 'text',
  },
  {
    country: 33, regex: '^39\\d{2}$', example: '3911', type: 'tel',
  },
  {
    country: 34, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 35, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 149, regex: '^(?:\\d{5})?$', example: '11111', type: 'tel',
  },
  {
    country: 37, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 38, regex: '^\\d{3}$', example: '111', type: 'tel',
  },
  {
    country: 39, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 40, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 44, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 152, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 153, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 48, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 157, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 51, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 52, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 159, regex: '^(\\d{4}([ ]?\\d{4})?)?$', example: '1111 1111', type: 'text',
  },
  {
    country: 162, regex: '^(948[5-9])|(949[0-7])$', example: '9485, 9491', type: 'tel',
  },
  {
    country: 55, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 163, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 57, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 59, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 165, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 60, regex: '^[A-Za-z]{3}[ ]?\\d{4}$', example: 'AAA1111', type: 'text',
  }, // Malta
  {
    country: 169, regex: '^(\\d{3}[A-Za-z]{2}\\d{3})?$', example: '111AA111', type: 'text',
  },
  {
    country: 61, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 63, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 64, regex: '^980\\d{2}$', example: '98011', type: 'tel',
  },
  {
    country: 171, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 176, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 67, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 178, regex: '^((\\d{4}-)?\\d{3}-\\d{3}(-\\d{1})?)?$', example: '111-111', type: 'text',
  },
  {
    country: 68, regex: '^(\\d{6})?$', example: '111111', type: 'tel',
  },
  {
    country: 180, regex: '^(PC |pc )?\\d{3}$', example: 'PC 111, 111', type: 'text',
  },
  {
    country: 72, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 75, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 286, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 78, regex: '^\\d{2}-?\\d{3}$', example: '11111, 11-111', type: 'text',
  }, // Poland
  {
    country: 249, regex: '^00[679]\\d{2}([ \\-]\\d{4})?$', example: '00611', type: 'tel',
  },
  {
    country: 80, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 81, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 189, regex: '^4789\\d$', example: '47891', type: 'tel',
  },
  {
    country: 191, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 192, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 86, regex: '^\\d{3}[ ]?\\d{2}$', example: '111 11', type: 'text',
  },
  {
    country: 87, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 88, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 90, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 204, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 93, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 208, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 96, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 209, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 97, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 213, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 214, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 216, regex: '^00120$', example: '00120', type: 'tel',
  },
  {
    country: 217, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 101, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 264, regex: '^6799$', example: '6799', type: 'tel',
  },
  {
    country: 309, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 84, regex: '^\\d{5}$', example: '11111', type: 'tel',
  }, // Serbia
  {
    country: 320, regex: '^8\\d{4}$', example: '81111', type: 'tel',
  },
  {
    country: 308, regex: '^6798$', example: '6798', type: 'tel',
  },
  {
    country: 141, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 310, regex: '^(FIQQ 1ZZ|fiqq 1zz)$', example: 'FIQQ 1ZZ', type: 'text',
  },
  {
    country: 262, regex: '^2899$', example: '2899', type: 'tel',
  },
  {
    country: 170, regex: '^(9694[1-4])([ \\-]?\\d{4})?$', example: '96941-1111', type: 'text',
  },
  {
    country: 276, regex: '^9[78]3\\d{2}$', example: '97311, 98311', type: 'tel',
  },
  {
    country: 146, regex: '^\\d{3}$', example: '111', type: 'tel',
  },
  {
    country: 253, regex: '^9[78][01]\\d{2}$', example: '97011', type: 'tel',
  },
  {
    country: 329, regex: '^(SIQQ 1ZZ|siqq 1zz)$', example: 'SIQQ 1ZZ', type: 'text',
  },
  {
    country: 247, regex: '^969[123]\\d([ \\-]?\\d{4})?$', example: '96911-1111', type: 'text',
  },
  {
    country: 147, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 314, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 150, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 158, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 160, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 54, regex: '^\\d{3}$', example: '111', type: 'tel',
  },
  {
    country: 164, regex: '^\\d{3}$', example: '111', type: 'tel',
  },
  {
    country: 167, regex: '^969[67]\\d([ \\-]?\\d{4})?$', example: '96961-1111', type: 'text',
  },
  {
    country: 65, regex: '^\\d{6}$', example: '111111', type: 'tel',
  },
  {
    country: 246, regex: '^9695[012]([ \\-]?\\d{4})?$', example: '96951-1111', type: 'text',
  },
  {
    country: 317, regex: '^9[78]2\\d{2}$', example: '97211', type: 'tel',
  },
  {
    country: 248, regex: '^988\\d{2}$', example: '98811', type: 'tel',
  },
  {
    country: 179, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 251, regex: '^008(([0-4]\\d)|(5[01]))([ \\-]?\\d{4})?$', example: '00811-1111', type: 'text',
  },
  {
    country: 277, regex: '^987\\d{2}$', example: '98711', type: 'tel',
  },
  {
    country: 74, regex: '^\\d{3}$', example: '111', type: 'tel',
  },
  {
    country: 327, regex: '^9[78]5\\d{2}$', example: '97511', type: 'tel',
  },
  {
    country: 322, regex: '^(PCRN 1ZZ|pcrn 1zz)$', example: 'PCRN 1ZZ', type: 'text',
  },
  {
    country: 181, regex: '^96940$', example: '96940', type: 'tel',
  },
  {
    country: 323, regex: '^9[78]4\\d{2}$', example: '97411', type: 'tel',
  },
  {
    country: 325, regex: '^(ASCN|STHL|ascn|sthl) 1ZZ|1zz$', example: 'ASCN 1ZZ, STHL 1ZZ', type: 'text',
  },
  {
    country: 331, regex: '^\\d{4}$', example: '1111', type: 'tel',
  },
  {
    country: 197, regex: '^\\d{5}$', example: '11111', type: 'tel',
  },
  {
    country: 200, regex: '^[HLMShlms]\\d{3}$', example: 'H111', type: 'text',
  },
  {
    country: 300, regex: '^(TKCA 1ZZ|tkca 1zz)$', example: 'TKCA 1ZZ', type: 'text',
  },
  {
    country: 335, regex: '^986\\d{2}$', example: '98611', type: 'tel',
  },
  {
    country: 318, regex: '^976\\d{2}$', example: '97611', type: 'tel',
  },
  {
    country: 42, regex: '^.{3,8}$', example: 'A11A111', type: 'text',
  }, // Ireland
]);
